// React imports.
import React from "react";

import { Assessment3StepsEnum } from "../state";
import { Assessment3VendorAssignedStatusEnum } from "../state";


const Assessment3VendorAssignedTopParagraph = ({fuelType }) => (
    <div>
        {fuelType.numHouseholds === 0
          &&<span>
              You have indicated that your state/territory does not serve households
              with&nbsp;{fuelType.descriptionHeat}&nbsp;. Therefore it would not be applicable for
              you to conduct a check of&nbsp;{fuelType.description}&nbsp;expenditure data.

          </span>
        }


        {fuelType.vendorAssignmentStatus == Assessment3VendorAssignedStatusEnum.Over95NoIssues
          &&<span>
                Your data recording and processing efforts for {fuelType.descriptionHeat}  households have
                not been flagged because more than 95% of your {fuelType.descriptionHeat}  households have
                a main heating vendor listed on file.
            </span>
          }
          {fuelType.vendorAssignmentStatus == Assessment3VendorAssignedStatusEnum.Under95NotMeetTarget
            &&<span>
                Your data recording and processing efforts for {fuelType.descriptionHeat}  households have been
                flagged because you only have {fuelType.percentHouseholdsAssignedVendor} of your households assigned to a main
                heating fuel vendor, which does not meet the 95% target. 
            </span>
          }
    </div>
);

export default Assessment3VendorAssignedTopParagraph;
